export default "__VITE_ASSET__SRdRz7nw__"